import type ResultConfig from "@/layout/header/searchBar/model/search/result/ResultConfig";

export default class ColumnConfig {
  constructor(
    public readonly i18nKey: string,
    public readonly searchInput = false,
    public parent?: ResultConfig,
  ) {}
}
